module.exports = __webpack_public_path__ + "static/media/kayden-kross.a3f6392f.jpg";